module.exports = __webpack_public_path__ + "img/logo-solency-white.559a844a.svg";